module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch14"
    }
  }, [_c('b', [_vm._v("Winter Facts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In the United States, the first day of winter is on the 21st or 22nd of December. But in Australia, it’s between June 20 and June 23.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("On average, winters in Europe were colder just a few hundred years ago. In fact, London’s river Thames sometimes froze completely during the winter, and between the 1400s and 1800s, Londoners held festivals called “frost fairs” on the ice.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("So much snow falls in the Japanese Alps during the winter that most buildings have entrances on their second stories.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("People have been building snowmen since the Middle Ages.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Largest ice-sculpting festival in the world: the World Ice Art Championships, held every March in Fairbanks, Alaska.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The legend of Jack Frost probably originated with the Vikings.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Symptoms of SAD (seasonal affective disorder): excessive sleeping, tiredness, depression, and physical aches.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Winter skating rinks in Moscow, Russia, cover more than 26,000 square feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', [_vm._v("*    *    *")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("MOTHER IN MOURNING")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', [_vm._v("According to ancient Greek mythology, winter began because Hades, god of the underworld, kidnapped Persephone, the daughter of the earth goddess Demeter. Eventually, Hades and Demeter worked out a deal where Persephone spent six months aboveground with her mother and six months below with Hades. But during the six months Persephone was away, Demeter became so depressed that she prevented plants and crops from growing, thus causing winter.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b710e2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter14.vue
// module id = 114
// module chunks = 0